import React, { useContext, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

import { type IntroStepsConfigValue } from '@/common/config/intro-steps';
import { Picture } from '@/components/ui/Picture/Picture';

import { IntroContext } from '../context';

interface CharacterPictureProps {
  config: IntroStepsConfigValue;
  skipFinishAnimation?: boolean;
}

const CharacterPicture: React.FC<CharacterPictureProps> = ({
  config,
  skipFinishAnimation,
}) => {
  const { isFinishOnboarding } = useContext(IntroContext);
  // const [isFlyingAway, setIsFlyingAway] = useState(false);
  // const [flyToHelpIconCoords, setFlyToHelpIconCoords] = useState<{
  //   x: number;
  //   y: number;
  // } | null>(null);
  const [initialCharCoords, setInitialCharCoords] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const characterRef = useRef<HTMLDivElement>(null);
  const { character } = config;

  useEffect(() => {
    if (characterRef.current) {
      const rect = characterRef.current.getBoundingClientRect();
      setInitialCharCoords({
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      });
    }
  }, []);

  // useEffect(() => {
  //   if (isFinishOnboarding && characterRef.current && helpIconBounds) {
  //     const charRect = characterRef.current.getBoundingClientRect();

  //     const deltaX =
  //       helpIconBounds.left +
  //       helpIconBounds.width / 2 -
  //       (charRect.left + charRect.width / 2);
  //     const deltaY =
  //       helpIconBounds.top +
  //       helpIconBounds.height / 2 -
  //       (charRect.top + charRect.height / 2);

  //     setFlyToHelpIconCoords({ x: deltaX, y: deltaY });
  //   }
  // }, [isFinishOnboarding, helpIconBounds]);

  // useEffect(() => {
  //   if (isFinishOnboarding) {
  //     setIsFlyingAway(true);
  //   }
  // }, [isFinishOnboarding]);

  return (
    <motion.div
      ref={characterRef}
      initial={{
        x: initialCharCoords?.x,
        y: initialCharCoords?.y,
        scale: 1,
      }}
      className={cn('absolute')}
      style={{
        //   height: character?.config?.height || '29.3125rem',
        //   width: character?.config?.width || '15.8125rem',
        left: character?.config?.left || '0',
        bottom: '0',
        // border: '1px solid red',
      }}
      //   initial={{
      //     x: 0,
      //     y: 0,
      //     scale: 1,
      //   }}
      animate={
        // isFlyingAway && flyToHelpIconCoords && initialCharCoords
        isFinishOnboarding && !skipFinishAnimation
          ? {
              x: '-100%',
              y: 0,
              // x: flyToHelpIconCoords.x,
              // y: flyToHelpIconCoords.y,
              // scale: 0.05,
              // opacity: 0,
            }
          : {
              x: 0,
              y: 0,
              scale: 1,
              opacity: 1,
            }
      }
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
        scale: { duration: 0.5, ease: 'easeInOut' },
      }}
    >
      <Picture
        // className={cn('absolute')}
        // style={{
        //   //   height: character?.config?.height || '29.3125rem',
        //   //   width: character?.config?.width || '15.8125rem',
        //   left: character?.config?.left || '0',
        //   bottom: '0',
        // }}
        img={character?.png}
        webp={character?.webp}
        alt="guide"
      />
    </motion.div>
  );
};

export default CharacterPicture;
